import React from "react";
import { Box, Button, Text, Typography } from "components/ui";
import { ComponentProps } from "react";
import { ArrowRight } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";

interface PaperProps {
	title: string;
	description: string;
	component: React.ReactNode;
	buttonLabel: string;
	hideButton?: boolean;
	buttonAction: () => void;
}

const PaperDashboardCard = (props: ComponentProps<typeof Box> & PaperProps) => {
	const { title, description, component, buttonLabel, buttonAction, hideButton } = props;
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	return (
		<Box {...props} padding={28} bg="$basicwhite" borderRadius={8} marginBottom={28}>
			<Typography.H3>{title}</Typography.H3>
			<Box my={20}>
				<Typography.Paragraph sx={{ textAlign: "center", fontFamily: "calibri" }}>{description}</Typography.Paragraph>
			</Box>
			{component}
			{!hideButton && <Box flexDirection="row" mt={32}>
				<Button onPress={buttonAction} variant="outline" gap={6} justifyContent="center">
					<Typography.Paragraph sx={{ color: "$primarylight", fontWeight: "bold" }}>{buttonLabel}</Typography.Paragraph>
					<ArrowRight color={resolvedPrimaryLight} />
				</Button>
			</Box>}
			{/* {props.children} */}
		</Box>
	);
};

export default PaperDashboardCard;
